export function getFromIdSubid(name, id, sub_id) {
    let { getFromIdSubidRequest, getFromIdSubidError, getFromIdSubidResult } = this.props

    this.doAction(
        this.HADES + 'get_from_id_subid',
        this.createBundle('get_from_id_subid', { name, id, sub_id }, this.POST, getFromIdSubidRequest, getFromIdSubidResult, getFromIdSubidError)
    )
}
